
import React from 'react';
import './skills.css';


const frontendSkills = [
    {
        title: 'Javascript',
        percentage: '95%',
        par: 'Frontend',
    },
    {
        title: 'React.js',
        percentage: '70%',
        par: 'Frontend',
    },
    {
        title: 'Next.js',
        percentage: '65%',
        par: 'Frontend',
    },
    {
        title: 'Vue.js',
        percentage: '80%',
        par: 'Frontend',
    },
]

const backendSkills = [
    {
        title: 'GraphCMS',
        percentage: '50%',
        par: 'Backend'
    },
    {
        title: 'Python',
        percentage: '60%',
        par: 'Backend'
    },
    {
        title: 'Sanity',
        percentage: '79%',
        par: 'Backend'
    },
    {
        title: 'Node.js',
        percentage: '80%',
        par: 'Backend'
    },
]
const Skills = () => {
  return (
    <div className="skills-wrapper d-flex gap-5">
        <div className="frontend-skills w-50">
            {
                frontendSkills.map((item,index)=>(
                    <SkillItem 
                        key={index} 
                        title={item.title} 
                        percentage={item.percentage}
                        par={item.par}
                    />
                ))
            }
        </div>
        <div className="backend-skills w-50">
            {
                backendSkills.map((item, index)=>(
                    <SkillItem
                        key={index}
                        title={item.title}
                        percentage={item.percentage}
                        par={item.par}
                    />
                ))
            }
        </div>
    </div>
  )
}

const SkillItem = ({title, percentage, par})=>{
   return <div className="skill-data mb-3">
        <div className="skill-title  d-flex align-items-center justify-content-between">
            <h6>{title}</h6>
            <span>{percentage}</span>
        </div>
        <div className="skill-bar">
            <span className="bar-percentage" style={{width: `${percentage}`}}></span>
        </div>
        <p>{par}</p>
    </div>
}

export default Skills